import { http } from '@/core/helpers/http.helper';
import { TargetGroupFilter } from '../../target-group-filters/target-group-filter.interface';

export class TargetGroupFilterService {
   async getTargetGroupFilters(teamId: number) {
      const response = await http.get(`/teams/${teamId}/target-group-filters`);
      return response.data;
   }

   async getTargetGroupFilter() {
      throw Error('Method not implemented');
   }

   async postTargetGroupFilters(teamId: number, targetGroupFilters: Array<TargetGroupFilter>) {
      const response = await http.post(`/teams/${teamId}/target-group-filters`, targetGroupFilters);
      return response.data;
   }

   async putTargetGroupFilter() {
      throw Error('Method not implemented');
   }

   async deleteTargetGroupFilter(teamId: number) {
      const response = await http.delete(`/teams/${teamId}/target-group-filters`);
      return response.data;
   }
}
